import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { JobField } from '@/@vxapp/Jobs/JobFieldStub'

export const JobsTableActions = [
  {
    id: 'preview',
    title: PageMeta.Projects.preview.title ?? 'Project preview',
    icon: 'tabler-eye',
    color: 'primary',
    route: {
      name: PageMeta.Projects.preview.name ?? '',
      paramKey: 'guid',
      itemKey: JobField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
] as const satisfies readonly TableActionSpec[]
